/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useDispatch} from "useDispatch";
import {useTranslation} from "react-i18next";
import CardComponent from "pages/Front/Booking/components/CardComponent";
import {Reservation} from "types/entities/Reservation";
import SellerCompanyForm from "pages/Front/Booking/Seller/components/SellerCompanyForm";
import {Company} from "types/entities/Company";
import {toast} from "react-toastify";
import BookingAction from "store/booking/BookingAction";
import {IdentificationIcon} from "@heroicons/react/24/solid";
import clsx from "clsx";
import ModalScrollableClose from "components/ModalScrollableClose";

interface BookingSellerCompanyModalProps {
    reservation: Reservation;
}

const BookingSellerCompanyModal = (props: BookingSellerCompanyModalProps) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onSubmittedCompanyHandler = (company: Company) => {
        dispatch(BookingAction.fetchEditCustomer(company)).then(r => {
            toast.success(t("Company updated"));
        });
    };

    return (
        <CardComponent className={"BookingSellerCompanyModal w-full md:min-w-[500px] max-w-[900px] !p-0 border border-gray-200 relative overflow-hidden h-auto max-h-full flex flex-col"}>
            <div
                className={
                    "top-0 z-30 sticky flex flex-row justify-between rounded-tl-lg rounded-tr-lg w-full px-3 py-3 font-bold border-b-2 border-gray-200 bg-gray-50 text-gray-900 drop-shadow-sm"
                }
            >
                <div className={"flex flex-row items-center"}>
                    <IdentificationIcon className={clsx("w-5 h-5 mr-1 text-gray-600/90 drop-shadow-xl")} />
                    <h4 className={"font-medium text-gray-700"}>{t("Company info")}</h4>
                </div>
                <ModalScrollableClose />
            </div>
            <div className={"flex w-full flex-col px-3 pt-3 pb-4 bg-gray-50 overflow-hidden h-auto rounded-bl-lg rounded-br-lg"}>
                <div className={"flex overflow-y-auto h-full"}>
                    <SellerCompanyForm
                        company={props.reservation?.company ? props.reservation.company : undefined}
                        editEnabled={true}
                        onSubmitted={onSubmittedCompanyHandler}
                        hideReservationNotes={true}
                    />
                </div>
            </div>
        </CardComponent>
    );
};

export default BookingSellerCompanyModal;
